export default __webpack_public_path__ + "static/media/csv.b851be1a.svg";